import React from 'react';
import {
  APP_MENU_HELP,
  APP_STEP_WORK_HELP,
  APP_STEP_WORK_ON_TAB_HELP,
  STEPS_TAB_HELP,
  WORKSHOP_PAGE_HELP,
  WORKSHOP_STEP_WORK_HELP,
  getStepHelpPanelTitle,
  StepHelpKey,
  HelpSectionContent,
} from '../data/stepHelpContent';
import HelpSectionView from './HelpSectionView';
import styles from '../styles/stepHelpPanel.module.css';

interface StepHelpPanelProps {
  isOpen: boolean;
  onClose: () => void;
  stepKey: StepHelpKey;
}

function buildSections(stepKey: StepHelpKey): HelpSectionContent[] {
  if (stepKey === 'workshop') {
    return [WORKSHOP_PAGE_HELP, WORKSHOP_STEP_WORK_HELP, APP_MENU_HELP];
  }

  if (stepKey === 'steps-tab') {
    return [STEPS_TAB_HELP, APP_STEP_WORK_ON_TAB_HELP, APP_MENU_HELP];
  }

  return [APP_STEP_WORK_HELP, APP_MENU_HELP];
}

const StepHelpPanel: React.FC<StepHelpPanelProps> = ({ isOpen, onClose, stepKey }) => {
  if (!isOpen) return null;

  const sections = buildSections(stepKey);

  return (
    <div className={styles.overlay} onClick={onClose} role="presentation">
      <div
        className={styles.panel}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="step-help-title"
      >
        <div className={styles.header}>
          <h2 id="step-help-title" className={styles.headerTitle}>
            {getStepHelpPanelTitle(stepKey)}
          </h2>
          <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close help">
            ×
          </button>
        </div>
        <div className={styles.body}>
          {sections.map((section) => (
            <section key={section.title} className={styles.helpSection}>
              <h3 className={styles.sectionHeading}>{section.title}</h3>
              <HelpSectionView content={section} />
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StepHelpPanel;
